import AppBodyContent from '@components/containers/app-body/AppBodyContent';
import {useState} from 'react';
import ComponentLoader from '@components/loaders/component-loader/ComponentLoader';
import FullScreenLoader from '@components/loaders/full-screen-loader/FullScreenLoader';
import {APP} from 'src/styles/variables';
import {ApplicationScreenMainDiv} from './PadViewPageStyle';
import {useTranslation} from 'react-i18next';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// import TextButton from '@components/button/text-button/TextButton';
import {LoadingButton} from '@mui/lab';

const PadViewPage = (props: any): JSX.Element => {
  const {t} = useTranslation();

  const [isPageLoading] = useState<boolean>(false);
  const [isComponentLoading] = useState<boolean>(false);

  // Based on id it will redirect to the module list screen
  const handleClick = () => {
    if (typeof props?.action === 'function') {
      props.action();
    }
  };

  const renderCreatePadButton = () => {
    return (
      <LoadingButton
        type="submit"
        variant="contained"
        onClick={() => handleClick()}
        sx={{
          backgroundColor: `${APP.PALETTE.MODULE_LAYOUT_COLOR.BUTTON}`,
          '&:hover': {
            backgroundColor: `${APP.PALETTE.MODULE_LAYOUT_COLOR.HOVER_BUTTON}`
          }
        }}>
        {t('PRIVATE.DASHBOARD.MODULE.CREATE_NEW_PAD', {ns: 'private'})}
      </LoadingButton>
    );
  };

  const renderBuildingApplicationScreen = () => {
    return (
      <ApplicationScreenMainDiv>
        <img
          src="https://newalltimehigh.com/wp-content/uploads/2022/06/make-app-blog-smarther.jpg"
          alt="image"
          width="15%"
          height="15%"
          style={{marginBottom: '1rem'}}
        />

        <div style={{marginBottom: '0.3rem', fontSize: 24}}>
          {t('PRIVATE.DASHBOARD.MODULE.START_BUILDING_YOUR_APPLICATION', {
            ns: 'private'
          })}
        </div>
        <div style={{marginBottom: '1rem', fontSize: 24}}>
          {t('PRIVATE.DASHBOARD.MODULE.CREATE_A_PAD', {ns: 'private'})}
        </div>
        <div>{renderCreatePadButton()}</div>
      </ApplicationScreenMainDiv>
    );
  };

  return isPageLoading ? (
    <FullScreenLoader />
  ) : (
    <AppBodyContent overflow="auto">
      {isComponentLoading ? (
        <ComponentLoader />
      ) : (
        renderBuildingApplicationScreen()
      )}
    </AppBodyContent>
  );
};

export default PadViewPage;
